import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';

@Injectable({ providedIn: 'root' })
export class ChallengeActivityStatusHttpService extends SupabaseBaseHttpService<
  'challenge_activity_statuses',
  'learning'
> {
  readonly schema = 'learning';
  readonly tableName = 'challenge_activity_statuses';
}
